@import '../../../global/style.scss';

:host {
  display: block;
}

.table-container {
  max-width: 100%;
  overflow-x: auto;
}

.col-label {
  display: none;
}

th {
  color: #626469;
  font-size: 12px;
  font-weight: normal;
}

td {
  color: #333;
  font-size: 14px;
}

th,
td {
  text-align: left;
  padding: 13px;
  background: #fff;
  border-bottom: 1px solid #e7e6e6;
}

th:first-child,
td:first-child {
  position: sticky;
  left: 0;
}

td:first-child {
  font-weight: bold;
}

th:first-child span {
  display: inline-block;
}

th:first-child span:first-child {
  margin-right: 3px;
}

th:first-child span:first-child::after {
  content: ' /';
}

table {
  white-space: nowrap;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 100%;
}

.row-1 {
  font-size: 14px;
  line-height: 17px;
  display: inline-block;
  margin-top: 4px;
  margin-bottom: 4px;
}

:host(.#{$smallScreenClass}) {
  table {
    width: 100%;
  }

  tr {
    display: block;
  }

  td {
    display: flex;
    border-bottom: 0;
    padding: 5px 0;
  }

  td > * {
    flex: 1 1;
  }

  td:last-child {
    border-bottom: 1px solid #e7e6e6;
    padding-bottom: 15px;
  }

  th:first-child,
  td:first-child {
    position: initial;
    padding: 15px 0;
  }

  th:first-child {
    display: flex;
    position: sticky;
    top: 0;
    padding: 10px 0;
  }

  th:not(:first-child) {
    display: none;
  }

  th:first-child span {
    flex: 1 1;
  }

  th:first-child span:first-child {
    margin: initial;
  }

  th:first-child span:first-child::after {
    content: none;
  }

  .col-label {
    display: inline-block;
    color: #626469;
  }
}

span.plus-symbol {
  color: #9fa0a4;
  vertical-align: middle;
}

.bundle-info > * {
  margin-right: 5px;
}

.bundle-info .row-1 ~ se-link {
  display: inline-block;
}

td se-link {
  margin-left: -4px;
}

td .bundle-info se-link {
  margin-right: 1px;
}

@media print {
  .table-container {
    margin-top: 30px;
    overflow: hidden;
    max-width: 100%;
  }

  .small.table-container {
    margin-top: 30px;
    overflow: hidden;
    max-width: 100%;
    width: 100%;
  }

  .small {
    td {
      text-align: left;
      padding: 15px;
      background: #fff;
      border-bottom: 1px solid #e7e6e6;
    }

    td,
    th {
      display: table-cell;
      border-bottom: initial;
      padding: 5px 0;
    }

    tr {
      display: table-row;
    }

    td:last-child {
      border-bottom: 1px solid #e7e6e6;
      padding-bottom: 15px;
    }

    .col-label {
      display: none;
    }

    th:first-child,
    td:first-child {
      position: table-cell;
      padding: 15px 0;
    }

    th:first-child {
      display: flex;
      position: initial;
      top: 0;
      padding: 10px 0;
    }

    th:not(:first-child) {
      display: table-header;
    }

    th:first-child span {
      flex: none;
    }

    th:first-child span:first-child::after {
      content: ' /';
    }
  }
}
